import axios from "axios";


const SDClient = {
    apiKey: "6fc8d34930b49ce9e28d4487632994cdaf170ef406a6f17742c17f7e0255e706",
    counter: 1,
    digest: async (message) => {
        return Array.prototype.map
            .call(
                new Uint8Array(
                    await crypto.subtle.digest(
                        "SHA-256",
                        new TextEncoder().encode(message)
                    )
                ),
                (x) => ("0" + x.toString(16)).slice(-2)
            )
            .join("");
    },
    encodeMessage: function (message) {
        return message;
    },
    ensureSession: function () {
        let session = localStorage.getItem("sd_session");
        if (!session) {
            // Mint a stable guest session so the cart persists server-side
            // under a known key and can be merged into the user on login
            // (the backend keys the guest cart by this `session` value).
            session =
                "guest-" +
                Math.random().toString(36).slice(2) +
                "-" +
                Date.now().toString(36);
            localStorage.setItem("sd_session", session);
        }
        return session;
    },
    endpoint: function (action, data = { _action: null }, options = {}) {
        let service = this;
        return new Promise(function (onSuccess, onError) {
            try {
                let message = {
                    message: service.encodeMessage(data),
                    session: service.ensureSession(),
                    // checksum: hash,
                    apiKey: service.apiKey,
                    counter: service.counter,
                };
                let axiosConfig = {};
                if (options.stripUserHeaders) {
                    // Mimic an unauthenticated request (like Postman): drop every
                    // user/auth header so the backend resolves data from message.user_id.
                    axiosConfig = {
                        headers: {
                            Authorization: null,
                            api_token: null,
                            user_id: null,
                            user_type: null,
                        },
                    };
                } else if (options.skipAuth) {
                    axiosConfig = { headers: { Authorization: null } };
                }
                axios
                    // .post(`https://sd.sunnydiamonds.com/api/api/refine/${action}`, message, {})
                    .post(global.postUrl + `refine/${action}`, message, axiosConfig)
                    .then(
                        (response) => {
                            if (response.status != 200) {
                                return;
                            }
                            data = response.data;
                            if (data.request && data.session) {
                                localStorage.setItem("sd_session", data.session);
                                onSuccess(data);
                            } else {
                                onError({
                                    request: false,
                                    reason: "REQUEST_FAILED",
                                    data: data,
                                });
                            }
                        },
                        (error) => {
                            if (error.response) {
                                if (error.response.status >= 500)
                                    onError({
                                        request: false,
                                        reason: "SERVER_ERROR",
                                    });
                                else if (error.response.status >= 300)
                                    onError({
                                        request: false,
                                        reason: "API_ERROR",
                                    });
                                else
                                    onError({
                                        request: false,
                                        reason: "NETWORK_ERROR",
                                    });
                            }
                            else
                                onError({
                                    request: false,
                                    reason: "REQUEST_FAILED",
                                });
                        }
                    );
                service.counter++;
            } catch (e) {
                onError({
                    request: false,
                    reason: "CLIENT_ERROR",
                    exception: e,
                });
            }
        });
    }
}

export default SDClient
